import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { LocationBaseComponent } from '@moduurnv2/libs-orderingapp';
import { Store } from '@ngxs/store';
import {  AuthState,  CustomerFavouritesService, environment,  SharedService,  UpdateFavouriteLocation,SetPaymentMethod } from '@moduurnv2/libs-orderingapp/src/core';

import { SetFutureDate,LocationState,DeliveryState } from '@moduurnv2/libs-orderingapp/src/core';
import { SweetAlertService } from '@moduurnv2/libs-orderingapp/src/core';
import { ModalService } from '../../../shared/modal/modal.service';
import { FuturePickerComponent } from '../../../shared';
import { LocationInfoComponent } from './../location-info/location-info.component';
import {TranslateService} from '@ngx-translate/core';
import { Plugins } from '@capacitor/core';
import { Config } from 'apps/orderingapp/web-orderingapp/src/config';
import { LoginDesktopComponent } from '../../../login/components/login-desktop/login-desktop.component';
import { takeUntil } from 'rxjs/operators';
const { Geolocation } = Plugins;

@Component({
  selector: 'moduurnv2-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss'],
})
export class LocationComponent extends LocationBaseComponent implements OnInit {
  isMobileView: boolean;
  constructor(
    public router: Router,
    public store: Store,
    public sweetAlert: SweetAlertService,
    modal: ModalService,
    public translate: TranslateService,
    public customerFavouriteService : CustomerFavouritesService,
    sharedService: SharedService
  ) {
    super(router, store, sweetAlert, translate,modal);
    sharedService.display.pipe(takeUntil(this.destroy$)).subscribe(
      (isMobileView) => (this.isMobileView = isMobileView))
  }

  openPicker: boolean = false;
  @Input() location;
  @Input() isLocationOn: boolean;
  @Input() showLocationImage: boolean;
  futureLocation;
  currLat: number;
  currLng: number;
  imageBaseUrl: string  =environment.imagebaseurl;
  futureOrderFromOrganization(location) {
    this.futureLocation = location;
    this.modal.showFuture(FuturePickerComponent, {
      data: {
        orderSettings: location.orderSettings,
        locationName: location.name,
        location: location,
      },
      whenClosed: (data) => {
        if (data) this.orderFromOrganization(location, data);
      },
    });
  }

  getFutureDate(futureTime) {
    this.orderFromOrganization(this.futureLocation);
    this.openPicker = false;
    const futureData = {
      location: this.futureLocation,
      futureTime: futureTime,
    };
    this.store.dispatch(new SetFutureDate(futureData));
  }

  getSelectedCoordinates() {
    let isRefinedLocation = localStorage.getItem('refinedLocation')
      ? JSON.parse(localStorage.getItem('refinedLocation'))
      : undefined;
    if (isRefinedLocation) {
      this.currLat = isRefinedLocation.coordinates[1];
      this.currLng = isRefinedLocation.coordinates[0];
    }
  }
  getlocation(selectedLng, selectedLat) {
    this.getSelectedCoordinates();
      Geolocation.getCurrentPosition()
        .then((position) => {
          if (position) {
            this.currLat = position.coords.latitude;
            this.currLng = position.coords.longitude;
            this.getSelectedCoordinates();
            this.mapsSelector(
              this.currLat,
              this.currLng,
              selectedLng,
              selectedLat
            );
          }
        })
        .catch((error) => {
          this.mapsSelector(
            this.currLat,
            this.currLng,
            selectedLng,
            selectedLat
          );
        })
  }
  mapsSelector(currentLat, currentLng, selectedLng, selectedLat) {
    if (
      /* if we're on iOS, open in Apple Maps */
      navigator.platform.indexOf('iPhone') != -1 ||
      navigator.platform.indexOf('iPad') != -1 ||
      navigator.platform.indexOf('iPod') != -1
    ) {      
      // var newWin = window.open(environment.mapbox.directionURLIOS); 
      let url;
      if (currentLat != undefined && currentLng != undefined) {
        url = environment.mapbox.directionURLIOS +
        'saddr=' +
        currentLat +
        ',' +
        currentLng +
        '&daddr=' +
        selectedLat +
        ',' +
        selectedLng +
        '&amp;ll='
        
       
      } else {
        url = environment.mapbox.directionURLIOS +
        '&daddr=' +
        selectedLat +
        ',' +
        selectedLng +
        '&amp;ll=';
       
      }
      window.location.assign(url);   
      // let newWin = window.open(url);
      
      //   if (!newWin || newWin.closed || typeof newWin.closed == 'undefined') {
      //     this.sweetAlert.alertWarning(
      //       '',
      //      this.translate.instant('dr')
      //     );
      //   }      


     
    } else {
      /* else use Google */     
      let url;
      if (currentLat != undefined && currentLng != undefined) {
        url = environment.mapbox.directionURL +
        'saddr=' +
        currentLat +
        ',' +
        currentLng +
        '&daddr=' +
        selectedLat +
        ',' +
        selectedLng +
        '&amp;ll='
        
       
      } else {
        url =environment.mapbox.directionURL +
        '&daddr=' +
        selectedLat +
        ',' +
        selectedLng +
        '&amp;ll=';
       
      }   
      let newWin = window.open(url);
        if (!newWin || newWin.closed || typeof newWin.closed == 'undefined') {
          this.sweetAlert.alertWarning(
            '',
            this.translate.instant('device-popup-blocker')
          );
        }      
     
    }
  }

  orderNowFromLocation(location) {
    const futureData = {
      location: this.futureLocation,
      futureTime: null,
    };
    this.store.dispatch(new SetFutureDate(futureData));
    this.orderFromOrganization(location);
  }

  openLocationInfoView() {
    // this.showLocationInfoModal = true; showMediumModalDesktop
    if(this.isMobileView){        
      this.modal.showLocationInfoModal(LocationInfoComponent, {data: {
        location: this.location,
      }})
    }else{
      this.modal.showMediumModalDesktop(LocationInfoComponent, {data: {
        location: this.location,
      }})
    }
    
  }
  // closeLocationInfoView() {
  //   this.showLocationInfoModal = false;
  // }

  orderFromLocation(location){
    // this.initService.load(Config.organizationId ,Config.appVersion).toPromise();
    if(location?.orderSettings?.asapOrder && location?.orderSettings?.futureOrder){
      const allowASAP = location.orderSettings.asapOrder.isAllow;
      const allowFuture = location.orderSettings.futureOrder.isAllow;
      const isLocationOpen = location.allow && location.isOpen;
      const locationDeliveryTypes = location.deliveryTypes;
      let isSelectedClassroomDelivery = false;
      const selectedLocation = this.store.selectSnapshot(LocationState.getSelectedLocation);
      const selectedDelivery = this.store.selectSnapshot(DeliveryState.getSelectedDelivery);
      if((locationDeliveryTypes?.length == 1 && locationDeliveryTypes[0].textCode == 'DELIVERYTYPE10') || (selectedLocation?._id == location._id && selectedDelivery?.textCode == 'DELIVERYTYPE10')){
        isSelectedClassroomDelivery = true;
      } else if(locationDeliveryTypes?.length > 1 && locationDeliveryTypes[0].textCode == 'DELIVERYTYPE10'){
        isSelectedClassroomDelivery = true;
      }

      if(isSelectedClassroomDelivery){
        let data ={
          isSelectedClassroomDelivery : isSelectedClassroomDelivery
        }
        this.orderFromOrganization(location,data);
      } else if(allowASAP && allowFuture && !isLocationOpen){
        this.futureOrderFromOrganization(location);
      } else if(allowASAP && allowFuture && isLocationOpen){
        this.orderNowFromLocation(location);
      } else if(!allowASAP && allowFuture && isLocationOpen){
        this.futureOrderFromOrganization(location);
      } else if(allowASAP && !allowFuture && isLocationOpen){
        this.orderNowFromLocation(location);
      } else if(!allowASAP && allowFuture && !isLocationOpen){
        this.futureOrderFromOrganization(location);
      } else if(!allowASAP && allowFuture && !isLocationOpen){
        this.futureOrderFromOrganization(location);
      } else if(allowASAP && !allowFuture && !isLocationOpen){
        this.orderNowFromLocation(location);
      } else{
        this.orderNowFromLocation(location);
      }

    }
  }

  getPreparationTime(location){
    let prepTime = location.preprationTime.split('-'); // prepTime[0] = minPreparationTime , prepTime[1] = maxPreparationTime
    return (+prepTime[0] ? location.preprationTime : `Less than ${+prepTime[1]}`)
  }
  

  favouriteLocationToggle(locDet){
    let customer = this.store.selectSnapshot(AuthState.getCommonAuthDetails);    
    // Getting Existing Favourited Location's Ids
    let locationFavPaylod = this.store.selectSnapshot(LocationState.getLocationsList).filter(filtLoc => filtLoc.isFavorited).map(mapLoc => mapLoc._id);
    locDet.isFavorited ? locationFavPaylod = locationFavPaylod.filter((locArr:any) => locArr !== locDet._id) : locationFavPaylod.push(locDet._id); // pushed clicked favourite id
      if(customer && customer.isLoggedIn){
        if(!locDet.iconLoading){ // To restrict multiple click when loading..
          locDet.iconLoading = true;
          this.store.dispatch(new UpdateFavouriteLocation(locationFavPaylod));
        }        
      }else{
       this.isMobileView ? this.router.navigate([`login`]) :  this.modal.showMediumModalDesktop(LoginDesktopComponent);        
      }     
  }
}
